import "./App.css";
import Header from "./components/Header";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { ToastContainer } from "react-toastify";
//import FormPage from "./components/NewFormPage";
//import FormPageOld from "./components/FormPageOld";
import FormPage from "./components/FormPage";

import LoginScreen from "./components/login";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';


function App() {
  // return (
  //   <div
  //     style={{ background: "rgb(246, 246, 246)" }}
  //     className="h-screen overflow-y-auto"
  //   ><AuthenticatedTemplate>
  //     <Header />
  //     <FormPage />
  //     <ToastContainer />
  //     </AuthenticatedTemplate>

  //     <UnauthenticatedTemplate>
  //       <LoginScreen />
  //     </UnauthenticatedTemplate>
  //   </div>
  // );

   const headerHeight = 64; // keep this in sync with Header.css

  return (
    <div
      style={{ background: "rgb(246, 246, 246)" }}
      className="h-screen overflow-y-auto"
    >
      <AuthenticatedTemplate>
        <Header />
        <main style={{ paddingTop: `${headerHeight}px` }}>
          <FormPage />
          <ToastContainer />
        </main>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <LoginScreen />
      </UnauthenticatedTemplate>
    </div>
  );
}


export default App;

//--------------------------------------------------------------------------------------------------


// import "./App.css";
// import Header from "./components/Header";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import FormPage from "./components/FormPage";

// import { ToastContainer } from "react-toastify";
// import LoginScreen from "./components/login";
// import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
// import Report from "./components/report";

// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


// function App() {
//   return (
//     <div
//       style={{ background: "rgb(246, 246, 246)" }}
//       className="h-screen overflow-y-auto"
//     >
//       <AuthenticatedTemplate>
        
//         <Router>
//           <Header />
//           <Routes>
          
//             <Route path="/" element={<FormPage />} />

            
//             <Route path="/report" element={<Report />} />
            
//           </Routes>
//         </Router>
//         <ToastContainer />
//       </AuthenticatedTemplate>

//       <UnauthenticatedTemplate>
//         <LoginScreen />
//       </UnauthenticatedTemplate>
//     </div>
//   );
// }

// export default App;
